/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/18/20
 * Time: 11:04 AM
 */
import React,{Component} from 'react';
import {Button} from "reactstrap";
import * as constants from "../../const/constants";
import {lang, language} from "../../const/language";
import {withRouter} from "react-router";


class App extends Component{

    render() {
        let {userType} = this.props;
        return userType !== 1 ?
                <div className={"auth-button-group"}>
                    <div className={"fixed-btn_ align-center"}>
                        <Button className="com-btn reg-btn mb-1 custom-size-full"
                                onClick={() => this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_REG_ROUTE}`)}>
                                                <span
                                                    className="nav-link-inner--text reg-text"> {language[lang].StudentRegistration} </span>
                            <span className="btn-inner--icon reg-flash"/>
                        </Button>
                    </div>
                    <div className={"fixed-btn_  align-center"}>
                        <Button className="com-btn log-btn black-btn custom-size-full"
                                onClick={() => this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`)}>
                                                <span
                                                    className="nav-link-inner--text reg-text"> {language[lang].LoginPage} </span>
                            <span className="btn-inner--icon reg-flash"/>
                        </Button>
                    </div>
                </div> : null
    }
}
export default withRouter(App);
